import NOTES from '../constants/NOTES';

export default function isAccidentalNote(note) {
  return NOTES.includes(note) && note.includes('#');
}



// WEBPACK FOOTER //
// ./src/lib/utils/isAccidentalNote.js